module.exports = __webpack_public_path__ + "img/37_91.20a44336.png";